import React, { useState } from 'react';
import { salesService, SaleInput } from '../../services/salesService';
import { toast } from 'react-hot-toast';

interface Props {
  onCreated?: () => void;
}

const SalesEntryForm: React.FC<Props> = ({ onCreated }) => {
  const [form, setForm] = useState<SaleInput>({
    date: new Date().toISOString().slice(0, 10),
    amount: 0,
    currency: 'GBP',
    product: '',
    channel: '',
    notes: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: name === 'amount' ? Number(value) : value }));
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!form.date || !form.amount) throw new Error('Date and amount are required');
      await salesService.create(form);
      toast.success('Sale recorded');
      setForm(f => ({ ...f, amount: 0, product: '', channel: '', notes: '' }));
      onCreated?.();
    } catch (err: any) {
      toast.error(err.message || 'Failed to save sale');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-white p-4 rounded shadow space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <label className="block text-sm font-medium">Date</label>
          <input type="date" name="date" value={form.date} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium">Amount</label>
          <input type="number" name="amount" value={form.amount} onChange={handleChange} className="mt-1 w-full border rounded p-2" step="0.01" />
        </div>
        <div>
          <label className="block text-sm font-medium">Currency</label>
          <input type="text" name="currency" value={form.currency} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <label className="block text-sm font-medium">Product</label>
          <input type="text" name="product" value={form.product} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium">Channel</label>
          <input type="text" name="channel" value={form.channel} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
        <div>
          <label className="block text-sm font-medium">Notes</label>
          <input type="text" name="notes" value={form.notes} onChange={handleChange} className="mt-1 w-full border rounded p-2" />
        </div>
      </div>
      <div>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : 'Add Sale'}</button>
      </div>
    </form>
  );
};

export default SalesEntryForm;
